<template>
  <button
    class="klickbox-step-button"
    v-if="step.kind !== 'thanks' && step.kind !== 'welcome'"
    @click="stepSetActive(step);modalOpen('duplicate-step')">
    <i class="kp-panel-copy"></i>
    <span class="step-subtitle">{{ $t('general.actions.duplicate') }}</span>
  </button>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: [
    'step',
  ],
  methods: mapActions([
    'modalOpen',
    'stepSetActive',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** ButtonDuplicate.vue?575ccb59
 **/